module.exports = __webpack_public_path__ + "img/taobao.007b136c.png";